import { GlassConcierge } from "./glass-concierge";
import { conciergeActions, useConciergeStore } from "../state/concierge-store";

/**
 * Mounts the Glass concierge modal. State lives in the module-level concierge
 * store so other surfaces (the hero search, the floating "What are you in the
 * mood for?" bar, prompt chips) open it with open / openWith(query).
 *
 * This used to also render the floating "Plan with AI" pill bottom-right.
 * The owner removed it (2026-10-05); the modal stays because those other
 * surfaces still open it, and this is the only place it is mounted.
 */
export function GlassConciergeLauncher() {
  const { open } = useConciergeStore();
  return <GlassConcierge open={open} onClose={() => conciergeActions.close()} />;
}
